import { getDefaultZIndex } from "@mantine/core";

// Keep critical case decisions above the floating observation control, below dropdowns.
export const LEGACY_CASE_MODAL_Z_INDEX = getDefaultZIndex("popover") - 1;
